import api from "./api";

export const createPayment = async (orderId, email, packId, productId) => {
  try {
    const result = await api.post("/orders", {
      email,
      order_id: orderId,
      pack_id: packId,
      product_id: productId,
    });

    return result.data;
  } catch (err) {
    console.log(`Failed to create order - ${err.message}`);
  }
};

export const processCardPayment = async (orderId, email, packId, productId, formData, additionalData) => {
  try {
    const submitData = {
      type: "online",
      total_amount: String(formData.transaction_amount),
      processing_mode: "automatic",
      email: email,
      order_id: orderId,
      pack_id: packId,
      product_id: productId,
      document: formData.payer?.identification?.number || "",
      transactions: {
        payments: [
          {
            amount: String(formData.transaction_amount),
            payment_method: {
              id: formData.payment_method_id,
              type: additionalData?.paymentTypeId || "credit_card",
              token: formData.token,
              installments: formData.installments,
            },
          },
        ],
      },
      payer: {
        email: formData.payer.email,
        identification: formData.payer.identification,
      },
    };

    const result = await api.post("/process_order", submitData);
    return result.data;
  } catch (err) {
    console.log(`Failed to process card payment - ${err.message}`);
    throw err;
  }
};
